export const getCurrentPosition = (onSuccess: (position: GeolocationPosition) => void) => {
    try {
        const error = () => {
            throw new Error('Unable to retrieve location');
        };

        if (!navigator.geolocation) {
            throw new Error('Geolocation is not supported by your device');
        } else {
            navigator.geolocation.getCurrentPosition(onSuccess, error, { enableHighAccuracy: true });
        }
    } catch (error) {
        console.error(error);
    }
};